import { render, staticRenderFns } from "./OrganisationGuideModal.vue?vue&type=template&id=451fa010&scoped=true"
import script from "./OrganisationGuideModal.vue?vue&type=script&lang=js"
export * from "./OrganisationGuideModal.vue?vue&type=script&lang=js"
import style0 from "./OrganisationGuideModal.vue?vue&type=style&index=0&id=451fa010&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451fa010",
  null
  
)

export default component.exports